import React from "react";
import { Button, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";

export default function ManageJobsInvitedSortDropdown({ label, onChange }) {
  return (
    <Dropdown
      overlay={
        <Menu onClick={onChange}>
          <Menu.Item key="most_relevant">Most Relevant</Menu.Item>
          <Menu.Item key="most_recent">Most Recent</Menu.Item>
        </Menu>
      }
      trigger={["click"]}
    >
      <Button className="manage-jobs-invited-page__toolbar-btn">
        {label}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
}
